import React, { useEffect } from 'react';
import { useLottieAnimation } from '@leagueplatform/lottie';
import { usePrefersReducedMotion } from '@leagueplatform/web-common';
import { RewardsAnimationComponentProps } from '#constants/types.ts';
import { Box } from '@leagueplatform/genesis-core';

const animationData = import('#assets/celebration-lines.lottie.json');

export default function CelebrationBadgeAnimation({
  animationRef,
  lottieConfig: configOverrides,
  shouldPlay,
}: RewardsAnimationComponentProps) {
  const prefersReducedMotion = usePrefersReducedMotion();

  const lottieConfig = {
    loop: false,
    autoplay: false,
    ...configOverrides,
  };
  const { animationContainerRef, animation } = useLottieAnimation({
    lottieConfig,
    animationRef,
    animationData,
  });

  useEffect(() => {
    if (shouldPlay) {
      animation?.goToAndPlay(0);
    }
  }, [shouldPlay, animation]);

  return prefersReducedMotion ? null : (
    <Box css={{ opacity: shouldPlay ? 1 : 0 }} ref={animationContainerRef} />
  );
}
